import React, { useState } from 'react';
import { Dialog, Toolbar, IconButton, Typography, Button, Icon } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './ReassignModal.styles';
import { get } from 'global/lib/lodash';
import Alert from '@material-ui/lab/Alert';
import { useScreen, Loader } from 'global/styles';
import sendData from 'redux/actions/sendData';
import Form from 'global/components/form';

export default (props) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({});

  const { isMobileXS } = useScreen();

  const classes = useStyles();

  const handleClose = (opts) => {
    props.onClose(opts);
  };

  const formSubmit = async () => {
    try {
      if (loading) {
        return;
      }

      setLoading(true);
      if (props.onFormSubmit) {
        await props.onFormSubmit(formState);
      } else {
        await Promise.all(
          props.tasks.map(async (task) => {
            const data = {
              data: {
                id: task.id,
                type: 'tasks',
                relationships: {
                  assignees: {
                    data: get(formState, 'assignedTo', []).map((a) => ({ type: 'users', role: 'assignee', id: a.id })),
                  },
                },
              },
            };
            await sendData({
              url: `/tasks/${task.id}`,
              method: 'patch',
              data,
            });
          })
        );
      }

      setLoading(false);
      handleClose(true);
    } catch (err) {
      setError(`Error: ${err.message}`);
      setLoading(false);
    }
  };

  const defaults = {
    contentTitle: 'Assign',
    contentSub: 'Who would you like to assign these tasks to?',
    ...props,
  };

  return (
    <Dialog className={classes.dialog} disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <Toolbar className={classes.toolbar}>
        <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close">
          <CloseIcon />
        </IconButton>

        <div className={classes.barTitle}>
          <Typography variant="h5" className={classes.title}>
            {props.title}
          </Typography>
        </div>
      </Toolbar>

      <div className={classes.container}>
        {error && (
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {error}
          </Alert>
        )}

        <div>
          <Typography variant="h5">{defaults.contentTitle}</Typography>
          <Typography variant="subtitle1">{defaults.contentSub}</Typography>
        </div>

        <div>
          <Form
            loading={loading}
            showAllScreens={true}
            formStyle={classes.formStyle}
            onSubmit={formSubmit}
            onFormState={(vals) => {
              setFormState(vals);
            }}
            screens={[
              {
                title: '',
                titleStyle: classes.titleStyle,
                screenContainerStyle: isMobileXS ? classes.screenContainerMobile : classes.screenContainer,
                screenContainer: {
                  props: {
                    className: classes.screenWidth,
                  },
                },
                inputs: [
                  {
                    id: 'assignedTo',
                    type: 'UserSelect',
                    defaultValue: () => get(props, 'tasks.0.assignees', []),
                    data: () => props.assignees,
                    props: {
                      label: 'Assigned To',
                      ...get(props, 'assignedToProps', {}),
                    },
                  },
                ],
              },
            ]}
          />

          <div className={classes.buttonContainer}>
            {typeof props.buttons === 'function' ? (
              props.buttons({ formState })
            ) : (
              <Button
                onClick={() => formSubmit()}
                startIcon={loading ? <Loader size={16} color="inherit" /> : <Icon>person_add</Icon>}
                className={classes.button}
                variant="contained"
                disabled={loading}
              >
                {props.okButton || 'RE-ASSIGN'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};
